var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolFieldForceScheduling01 = function SvgSolFieldForceScheduling01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_field_force_scheduling-01_svg2__a",
    x1: 18.12,
    x2: 152.78,
    y1: 144.85,
    y2: 53.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__b",
    x1: 18.12,
    x2: 152.78,
    y1: 144.85,
    y2: 53.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__c",
    x1: 10.74,
    x2: 145.4,
    y1: 133.92,
    y2: 43.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__d",
    x1: 10.74,
    x2: 145.4,
    y1: 133.92,
    y2: 43.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__e",
    x1: 19.85,
    x2: 154.51,
    y1: 147.43,
    y2: 56.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__f",
    x1: 19.85,
    x2: 154.51,
    y1: 147.43,
    y2: 56.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__g",
    x1: 28.97,
    x2: 163.63,
    y1: 160.94,
    y2: 70.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__h",
    x1: 28.97,
    x2: 163.63,
    y1: 160.94,
    y2: 70.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__i",
    x1: 20.11,
    x2: 154.77,
    y1: 147.81,
    y2: 56.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__j",
    x1: 20.11,
    x2: 154.77,
    y1: 147.81,
    y2: 56.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__k",
    x1: 29.23,
    x2: 163.89,
    y1: 161.32,
    y2: 70.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__l",
    x1: 29.23,
    x2: 163.89,
    y1: 161.32,
    y2: 70.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__m",
    x1: 38.35,
    x2: 173.01,
    y1: 174.83,
    y2: 83.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__n",
    x1: 38.35,
    x2: 173.01,
    y1: 174.83,
    y2: 83.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__o",
    x1: 38.6,
    x2: 173.26,
    y1: 175.21,
    y2: 84.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__p",
    x1: 38.6,
    x2: 173.26,
    y1: 175.21,
    y2: 84.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__q",
    x1: 3.34,
    x2: 138,
    y1: 122.96,
    y2: 32.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__r",
    x1: 3.34,
    x2: 138,
    y1: 122.96,
    y2: 32.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__s",
    x1: 3.34,
    x2: 138,
    y1: 122.96,
    y2: 32.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__t",
    x1: 3.34,
    x2: 138,
    y1: 122.96,
    y2: 32.06
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__u",
    x1: 48.35,
    x2: 183.01,
    y1: 189.65,
    y2: 98.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__v",
    x1: 48.35,
    x2: 183.01,
    y1: 189.65,
    y2: 98.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__w",
    x1: 48.35,
    x2: 183.01,
    y1: 189.65,
    y2: 98.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_field_force_scheduling-01_svg2__a",
    id: "sol_field_force_scheduling-01_svg2__x",
    x1: 48.35,
    x2: 183.01,
    y1: 189.65,
    y2: 98.76
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.66 18.13h-15.72V9.25c0-4.83-3.93-8.75-8.75-8.75h-.73c-4.83 0-8.75 3.93-8.75 8.75v8.88H95.48V9.25c0-4.83-3.93-8.75-8.75-8.75H86c-4.83 0-8.75 3.93-8.75 8.75v8.88H61.53c-5.36 0-9.71 4.35-9.71 9.69v16.01h4.33V27.82c0-2.96 2.42-5.36 5.39-5.36h15.72v1.23c0 4.83 3.93 8.75 8.75 8.75h.73c4.82 0 8.75-3.93 8.75-8.75v-1.23h60.23v1.23c0 4.83 3.93 8.75 8.75 8.75h.73c4.83 0 8.75-3.93 8.75-8.75v-1.23h15.72c2.97 0 5.39 2.41 5.39 5.36v17.67H59.01v4.33h136.04v67.88c0 2.97-2.42 5.39-5.39 5.39h-45.88v4.33h45.88c5.36 0 9.71-4.36 9.71-9.71V27.82c0-5.34-4.36-9.69-9.71-9.69m-98.51 5.55a4.43 4.43 0 0 1-4.42 4.43H86c-2.44 0-4.43-1.99-4.43-4.43V9.25c0-2.44 1.99-4.43 4.43-4.43h.73a4.43 4.43 0 0 1 4.42 4.43zm78.47 0c0 2.44-1.99 4.43-4.43 4.43h-.73c-2.44 0-4.43-1.99-4.43-4.43V9.25c0-2.44 1.99-4.43 4.43-4.43h.73c2.44 0 4.43 1.99 4.43 4.43z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66 127.9h-46.38v-5.32h46.38c2.7 0 4.89-2.19 4.89-4.89V50.31H58.51v-5.32h136.04V27.81c0-2.68-2.19-4.87-4.89-4.87h-15.22v.73c0 5.1-4.15 9.25-9.25 9.25h-.73c-5.1 0-9.25-4.15-9.25-9.25v-.73H95.97v.73c0 5.1-4.15 9.25-9.25 9.25h-.73c-5.1 0-9.25-4.15-9.25-9.25v-.73H61.51c-2.7 0-4.89 2.18-4.89 4.87v16.5H51.3v-16.5c0-5.62 4.58-10.19 10.21-10.19h15.23V9.24c0-5.1 4.15-9.25 9.25-9.25h.73c5.1 0 9.25 4.15 9.25 9.25v8.38h59.24V9.24c0-5.1 4.15-9.25 9.25-9.25h.73c5.1 0 9.25 4.15 9.25 9.25v8.38h15.22c5.63 0 10.21 4.57 10.21 10.19v89.88c0 5.63-4.58 10.21-10.21 10.21m-45.38-.99h45.38c5.08 0 9.22-4.13 9.22-9.21V27.82c0-5.07-4.13-9.19-9.22-9.19h-16.21V9.26c0-4.55-3.7-8.25-8.25-8.25h-.73c-4.55 0-8.25 3.7-8.25 8.25v9.37H94.99V9.26c0-4.55-3.7-8.25-8.25-8.25h-.73c-4.55 0-8.26 3.7-8.26 8.25v9.37H61.53c-5.08 0-9.22 4.12-9.22 9.19v15.51h3.33V27.82c0-3.23 2.64-5.86 5.88-5.86h16.22v1.73c0 4.55 3.7 8.25 8.26 8.25h.73c4.55 0 8.25-3.7 8.25-8.25v-1.73h61.23v1.73c0 4.55 3.7 8.25 8.25 8.25h.73c4.55 0 8.25-3.7 8.25-8.25v-1.73h16.21c3.24 0 5.88 2.63 5.88 5.86v18.17H59.5v3.33h136.04v68.38a5.89 5.89 0 0 1-5.88 5.88h-45.38zm20.91-98.31h-.73a4.93 4.93 0 0 1-4.92-4.92V9.25a4.93 4.93 0 0 1 4.92-4.92h.73a4.93 4.93 0 0 1 4.92 4.92v14.43a4.93 4.93 0 0 1-4.92 4.92m-.73-23.28a3.93 3.93 0 0 0-3.93 3.93v14.43a3.93 3.93 0 0 0 3.93 3.93h.73a3.93 3.93 0 0 0 3.93-3.93V9.25a3.93 3.93 0 0 0-3.93-3.93zM86.72 28.6h-.73a4.93 4.93 0 0 1-4.92-4.92V9.25a4.93 4.93 0 0 1 4.92-4.92h.73a4.93 4.93 0 0 1 4.92 4.92v14.43a4.93 4.93 0 0 1-4.92 4.92m-.73-23.28a3.93 3.93 0 0 0-3.93 3.93v14.43a3.93 3.93 0 0 0 3.93 3.93h.73a3.93 3.93 0 0 0 3.93-3.93V9.25a3.93 3.93 0 0 0-3.93-3.93z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.07 64.06h13.91v4.33h-13.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47 68.89h-14.9v-5.32h14.9zm-13.9-1h12.91v-3.33h-12.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 64.06h13.91v4.33H133.2z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61 68.89h-14.9v-5.32h14.9zm-13.91-1h12.91v-3.33H133.7z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33 64.06h13.91v4.33h-13.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74 68.89h-14.9v-5.32h14.9zm-13.91-1h12.91v-3.33h-12.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.07 84.28h13.91v4.33h-13.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47 89.1h-14.9v-5.32h14.9zm-13.9-.99h12.91v-3.33h-12.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 84.28h13.91v4.33H133.2z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61 89.1h-14.9v-5.32h14.9zm-13.91-.99h12.91v-3.33H133.7z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33 84.28h13.91v4.33h-13.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74 89.1h-14.9v-5.32h14.9zm-13.91-.99h12.91v-3.33h-12.91z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2 104.5h13.91v4.33H133.2z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61 109.32h-14.9V104h14.9zm-13.91-.99h12.91V105H133.7z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86 77.67c-10.26 0-18.61 8.35-18.61 18.61s8.35 18.61 18.61 18.61 18.61-8.35 18.61-18.61-8.35-18.61-18.61-18.61m0 32.89c-7.88 0-14.28-6.41-14.28-14.28S34.99 82 42.86 82s14.28 6.41 14.28 14.28-6.41 14.28-14.28 14.28",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86 115.39c-10.54 0-19.11-8.57-19.11-19.11s8.57-19.11 19.11-19.11 19.11 8.57 19.11 19.11-8.57 19.11-19.11 19.11m0-37.22c-9.99 0-18.11 8.13-18.11 18.11s8.13 18.11 18.11 18.11 18.11-8.13 18.11-18.11-8.13-18.11-18.11-18.11m0 32.89c-8.15 0-14.78-6.63-14.78-14.78S34.71 81.5 42.86 81.5s14.78 6.63 14.78 14.78-6.63 14.78-14.78 14.78m0-28.57c-7.6 0-13.79 6.19-13.79 13.79s6.18 13.79 13.79 13.79 13.79-6.18 13.79-13.79-6.19-13.79-13.79-13.79",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.03 125.84 2.66-.93 7.38-12.79-.52-2.77-7.91-6.34c.46-2.28.69-4.54.69-6.73s-.23-4.45-.69-6.73l7.91-6.34.52-2.77-7.38-12.79-2.66-.93-9.45 3.68c-3.4-2.99-7.39-5.3-11.65-6.74l-1.54-10.01-2.14-1.83H35.49l-2.14 1.83-1.54 10.01a34.3 34.3 0 0 0-11.65 6.74l-9.46-3.68-2.66.93L.66 80.44l.52 2.77 7.91 6.34c-.46 2.28-.69 4.54-.69 6.73s.23 4.45.69 6.73l-7.91 6.34-.52 2.77 7.38 12.79 2.66.93 9.46-3.68c3.4 2.99 7.39 5.3 11.65 6.74l1.54 10.01 2.14 1.83h14.76l2.14-1.83 1.54-10.01c4.27-1.44 8.25-3.75 11.65-6.74zm-23.65-.67-1.53 1.75-1.46 9.51H37.34l-1.47-9.51-1.53-1.75a29.9 29.9 0 0 1-12.23-7.08l-2.28-.45-8.98 3.5-5.52-9.57 7.51-6.02.75-2.19c-.58-2.41-.87-4.78-.87-7.07s.29-4.66.87-7.07l-.75-2.19-7.51-6.02 5.52-9.57 8.98 3.5 2.28-.45c3.46-3.3 7.69-5.75 12.23-7.08l1.53-1.75 1.47-9.51h11.05l1.46 9.51 1.53 1.75c4.55 1.33 8.78 3.78 12.23 7.08l2.28.45 8.98-3.5 5.53 9.57-7.51 6.02-.75 2.19c.58 2.41.87 4.79.87 7.07s-.29 4.66-.87 7.07l.75 2.19 7.51 6.02-5.53 9.57-8.98-3.5-2.28.45c-3.46 3.3-7.69 5.75-12.23 7.08",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.43 141.25H35.3l-2.42-2.07-1.53-9.9c-4.1-1.43-8-3.69-11.31-6.54l-9.35 3.64-3.01-1.06-7.55-13.11.59-3.13 7.82-6.27c-.43-2.21-.65-4.4-.65-6.53s.22-4.32.65-6.53L.72 83.48l-.59-3.13 7.56-13.11 3.01-1.06 9.35 3.64a35.1 35.1 0 0 1 11.31-6.54l1.53-9.9 2.42-2.07h15.13l2.42 2.07 1.52 9.9c4.1 1.43 8 3.69 11.31 6.54l9.35-3.64 3.01 1.06.09.16 7.47 12.95-.59 3.13-7.82 6.27c.43 2.21.65 4.41.65 6.53s-.22 4.31-.65 6.53l7.82 6.27.59 3.13-7.56 13.11-3.01 1.06-9.35-3.64c-3.31 2.86-7.2 5.11-11.31 6.54l-1.52 9.9-2.42 2.07Zm-14.76-1h14.39l1.86-1.59 1.56-10.13.29-.1a34.2 34.2 0 0 0 11.49-6.65l.23-.2 9.56 3.73 2.31-.81 7.2-12.47-.45-2.41-8-6.42.06-.3c.45-2.25.68-4.48.68-6.63s-.23-4.38-.68-6.63l-.06-.3 8-6.42.45-2.41-7.2-12.47-2.31-.81-9.56 3.73-.23-.2a34.2 34.2 0 0 0-11.49-6.65l-.29-.1-1.56-10.13-1.86-1.59H35.67l-1.86 1.59-1.56 10.13-.29.1a34 34 0 0 0-11.49 6.65l-.23.2-9.56-3.73-2.31.81-7.2 12.47.45 2.41 8 6.42-.06.3c-.46 2.24-.69 4.47-.69 6.63s.23 4.39.69 6.63l.06.3-8 6.42-.45 2.41 7.2 12.47 2.31.81 9.56-3.73.23.2a34.2 34.2 0 0 0 11.49 6.65l.29.1 1.56 10.13zm13.14-3.33h-11.9l-1.51-9.78-1.34-1.53c-4.53-1.35-8.73-3.79-12.19-7.06l-1.99-.4-9.24 3.6-5.95-10.31 7.73-6.2.66-1.92c-.57-2.4-.86-4.77-.86-7.04s.29-4.65.86-7.04l-.66-1.92-7.73-6.2 5.95-10.31 9.24 3.6 1.99-.4c3.46-3.27 7.67-5.7 12.19-7.06l1.34-1.53 1.51-9.78h11.9l1.51 9.78 1.34 1.53c4.53 1.35 8.74 3.79 12.19 7.06l2 .39 9.24-3.6 5.95 10.31-7.73 6.2-.66 1.92c.57 2.4.85 4.77.85 7.05s-.29 4.65-.85 7.04l.66 1.92 7.73 6.2-5.95 10.31-9.24-3.6-2 .39a30.6 30.6 0 0 1-12.19 7.06l-1.34 1.53-1.51 9.78Zm-11.05-.99h10.2l1.42-9.23 1.72-1.96.14-.04c4.47-1.31 8.63-3.72 12.03-6.96l.1-.1 2.56-.51 8.71 3.4 5.1-8.83-7.29-5.85-.84-2.47.03-.14c.57-2.37.86-4.71.86-6.95s-.29-4.59-.86-6.95l-.03-.14.84-2.47 7.29-5.85-5.1-8.83-8.71 3.39-2.56-.51-.1-.1c-3.4-3.24-7.56-5.65-12.03-6.96l-.14-.04-1.72-1.96-1.42-9.23h-10.2l-1.42 9.23-1.72 1.96-.14.04a29.6 29.6 0 0 0-12.03 6.96l-.1.1-2.56.51-8.72-3.39-5.1 8.83 7.29 5.85.84 2.47-.03.14c-.57 2.37-.86 4.71-.86 6.95s.29 4.58.86 6.95l.03.14-.84 2.47-7.29 5.85 5.1 8.83 8.72-3.4 2.56.51.1.1c3.4 3.24 7.56 5.65 12.03 6.96l.14.04 1.72 1.96z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.85 139.19-7.38-12.79-2.66-.93-9.46 3.68c-3.4-2.99-7.39-5.3-11.65-6.74l-1.54-10.01-2.14-1.83H92.26l-2.14 1.83-1.54 10.01a34.3 34.3 0 0 0-11.65 6.74l-9.46-3.68-2.66.93-7.38 12.79.52 2.77 7.91 6.34c-.46 2.28-.69 4.54-.69 6.73s.23 4.45.69 6.73l-7.91 6.34-.52 2.77 7.38 12.79 2.66.93 9.46-3.68c3.4 2.99 7.39 5.3 11.65 6.74l1.54 10.01 2.14 1.83h14.76l2.14-1.83 1.54-10.01c4.27-1.44 8.25-3.75 11.65-6.74l9.46 3.68 2.66-.93 7.38-12.79-.52-2.77-7.91-6.34c.46-2.28.69-4.54.69-6.73s-.23-4.45-.69-6.73l7.91-6.34zm-12.19 6.58-.75 2.19c.58 2.41.87 4.79.87 7.07s-.29 4.66-.87 7.07l.75 2.19 7.51 6.02-5.52 9.57-8.98-3.5-2.28.45c-3.45 3.3-7.68 5.75-12.23 7.08l-1.53 1.75-1.46 9.51H94.12l-1.46-9.51-1.53-1.75a29.9 29.9 0 0 1-12.23-7.08l-2.28-.45-8.98 3.5-5.52-9.57 7.51-6.02.75-2.19c-.58-2.41-.87-4.79-.87-7.07s.29-4.66.87-7.07l-.75-2.19-7.51-6.02 5.52-9.57 8.98 3.5 2.28-.45c3.46-3.3 7.69-5.75 12.23-7.08l1.53-1.75 1.46-9.51h11.05l1.46 9.51 1.53 1.75c4.55 1.33 8.78 3.78 12.23 7.08l2.28.45 8.98-3.5 5.52 9.57z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21 200H92.08l-2.42-2.07-1.52-9.9c-4.1-1.43-8-3.69-11.31-6.54l-9.35 3.64-3.01-1.06-7.56-13.1.59-3.13 7.82-6.27c-.43-2.21-.64-4.41-.64-6.53s.22-4.32.64-6.53l-7.82-6.27-.59-3.13L64.47 126l3.01-1.06 9.35 3.64a35.1 35.1 0 0 1 11.31-6.54l1.52-9.9 2.42-2.07h15.13l2.42 2.07 1.52 9.9c4.1 1.43 8 3.69 11.31 6.54l9.35-3.64 3.01 1.06 7.56 13.1-.59 3.13-7.82 6.27c.43 2.22.65 4.41.65 6.53s-.22 4.32-.65 6.53l7.82 6.27.59 3.13-7.56 13.1-3.01 1.06-9.35-3.64a35.1 35.1 0 0 1-11.31 6.54l-1.52 9.9-2.42 2.07Zm-14.76-.99h14.39l1.86-1.59 1.56-10.13.29-.1a34.2 34.2 0 0 0 11.49-6.65l.23-.2 9.57 3.73 2.31-.81 7.2-12.47-.45-2.41-8-6.42.06-.3c.45-2.25.68-4.48.68-6.63s-.23-4.38-.68-6.63l-.06-.3 8-6.42.45-2.41-7.2-12.47-2.31-.81-9.57 3.73-.23-.2a34.2 34.2 0 0 0-11.49-6.65l-.29-.1-1.56-10.13-1.86-1.59H92.45l-1.86 1.59-1.56 10.13-.29.1a34.2 34.2 0 0 0-11.49 6.65l-.23.2-9.56-3.73-2.31.81-7.2 12.47.45 2.41 8 6.42-.06.3c-.45 2.25-.68 4.48-.68 6.63s.23 4.38.68 6.63l.06.3-8 6.42-.45 2.41 7.2 12.47 2.31.81 9.56-3.73.23.2a34.2 34.2 0 0 0 11.49 6.65l.29.1 1.56 10.13zm13.14-3.34h-11.9l-1.51-9.79-1.34-1.53c-4.53-1.35-8.73-3.79-12.19-7.06l-1.99-.39-9.24 3.6-5.95-10.31 7.73-6.2.66-1.92c-.57-2.4-.85-4.77-.85-7.05s.29-4.65.85-7.05l-.66-1.92-7.73-6.2 5.95-10.31 9.24 3.6 1.99-.39c3.46-3.27 7.67-5.71 12.19-7.06l1.34-1.53 1.51-9.79h11.9l1.51 9.79 1.34 1.53c4.52 1.35 8.73 3.79 12.19 7.06l1.99.39 9.24-3.6 5.95 10.31-7.73 6.2-.66 1.92c.57 2.4.85 4.77.85 7.05s-.29 4.65-.85 7.05l.66 1.92 7.73 6.2-5.95 10.31-9.24-3.6-1.99.39a30.6 30.6 0 0 1-12.19 7.06l-1.34 1.53zm-11.05-.99h10.2l1.42-9.23 1.72-1.96.14-.04c4.47-1.31 8.63-3.72 12.03-6.96l.1-.1 2.56-.51 8.72 3.39 5.1-8.83-7.29-5.85-.84-2.47.03-.14c.57-2.37.86-4.71.86-6.95s-.29-4.58-.86-6.95l-.03-.14.84-2.47 7.29-5.85-5.1-8.83-8.72 3.39-2.56-.51-.1-.1c-3.4-3.24-7.56-5.65-12.03-6.96l-.14-.04-1.72-1.96-1.42-9.23h-10.2l-1.42 9.23-1.72 1.96-.14.04a29.6 29.6 0 0 0-12.03 6.96l-.1.1-2.56.51-8.72-3.39-5.1 8.83 7.29 5.85.84 2.47-.03.14c-.57 2.37-.86 4.71-.86 6.95s.29 4.58.86 6.95l.03.14-.84 2.47-7.29 5.85 5.1 8.83 8.72-3.39 2.56.51.1.1c3.4 3.24 7.56 5.65 12.03 6.96l.14.04 1.72 1.96z",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64 136.42c-10.26 0-18.61 8.35-18.61 18.61s8.35 18.61 18.61 18.61 18.61-8.35 18.61-18.61-8.35-18.61-18.61-18.61m0 32.9c-7.88 0-14.28-6.41-14.28-14.28s6.41-14.28 14.28-14.28 14.28 6.41 14.28 14.28-6.41 14.28-14.28 14.28",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64 174.14c-10.54 0-19.11-8.57-19.11-19.11s8.57-19.11 19.11-19.11 19.11 8.57 19.11 19.11-8.57 19.11-19.11 19.11m0-37.22c-9.99 0-18.11 8.13-18.11 18.11s8.13 18.11 18.11 18.11 18.11-8.13 18.11-18.11-8.13-18.11-18.11-18.11m0 32.89c-8.15 0-14.78-6.63-14.78-14.78s6.63-14.78 14.78-14.78 14.78 6.63 14.78 14.78-6.63 14.78-14.78 14.78m0-28.56c-7.6 0-13.79 6.19-13.79 13.79s6.18 13.79 13.79 13.79 13.79-6.18 13.79-13.79-6.19-13.79-13.79-13.79",
    style: {
      fill: "url(#sol_field_force_scheduling-01_svg2__x)"
    }
  }));
};
export default SvgSolFieldForceScheduling01;